<woa-modal-page-layout>
    <div class="qr-container">
        <woa-qr-code [errorCorrectionLevel]="'M'" [width]="200" [value]="value()"></woa-qr-code>
    </div>
    <div class="qr-text">
        <div class="qr-text-label">{{ message() }}:</div>
        <div class="qr-text-code">{{ displayValue() }}</div>
    </div>
</woa-modal-page-layout>
